<template>

</template>

<script>

    import { glueParamsToUrl } from "../../../commonjs/helpers";
    import {mapState} from 'vuex';

    export default {
        name: "BackgroundVideoMixin",
        data () {
            return {
                vimeoUrlKeys : {
                    "autoplay": "autoplay",
                    "mute" : "muted",
                    "loop" : "loop"
                },
                wistiaUrlKeys : {
                    "autoplay" : "autoPlay",
                    "mute" : "muted",
                    "loop" : "endVideoBehavior"
                },
            }
        },
        computed: {
            ...mapState('UiInteractions',[
                'viewportWidth'
            ]),
            hasVideoData () {
                return this.myData?.videoMediaData?.video;
            },
        },
        methods: {
            showVideo () {
                this.toggleVideoWrapperDisplay(true);
            },
            insertVideo (videoWrapper,frame) {
                videoWrapper.appendChild(frame);
                this.addVideoListeners(videoWrapper, frame);
            },
            createVideo () {
                let params = this.getRenderVideoParams();
                let videoWrapper = this.getVideoWrapper();
                let videoUrl = this.getVideoUrl();

                if (!videoWrapper) {
                    videoWrapper = this.createVideoWrapper();
                }

                let frame = this.getFrameNode();

                if (!frame) {
                    frame = this.createVideoFrame();
                }

                this.handleVideoPopupAppearance(params);

                if( this.myData?.videoMediaData?.hideVideoBelow) {

                    if (this.myData.videoMediaData.hideVideoBelow !== 'None' && parseInt(this.myData.videoMediaData.hideVideoBelow) > this.viewportWidth) {
                        videoWrapper.classList.add('hide-video');

                        if (params && params.autoplay) {
                            params.autoplay = false;
                        }

                        videoWrapper.style.backgroundImage = this.getFallbackImageOrGradient();
                    }
                }

                frame.setAttribute("src", videoUrl);
                this.insertVideo(videoWrapper,frame);
            },
            renderVideo () {
                this.createVideo();
                this.showVideo();
            },
            getVideoWrapper (wrapper) {
                if (!wrapper) {
                    wrapper = this.myNode;
                }

                let videoWrapper = null;

                if (wrapper && wrapper.querySelector(".js-video-wrapper")) {
                    videoWrapper = wrapper.querySelector(".js-video-wrapper");
                }

                return videoWrapper;
            },
            createVideoWrapper () {
                let videoWrapper = document.createElement('div');
                videoWrapper.classList.add("js-video-wrapper");

                this.myNode.appendChild(videoWrapper);
                return videoWrapper;
            },
            getFrameNode (wrapper) {
                if (!wrapper) {
                    wrapper = this.getVideoWrapper();
                }
                return wrapper && wrapper.querySelector(".js-video-frame") ? wrapper.querySelector(".js-video-frame") : null;
            },
            toggleVideoWrapperDisplay (flag) {
                let videoWrapper = this.getVideoWrapper();

                if (videoWrapper) {

                    if (flag) {
                        videoWrapper.style.display = "block";
                    } else {
                        videoWrapper.style.display = "none";
                    }

                }

                if (this.hasVideoData && !this.getFrameNode()) {
                    this.createVideo();
                }
            },
            getFrameSrc(){
                if(this.myData.videoMediaData && this.myData.videoMediaData.video){
                    let video = this.myData.videoMediaData.video;
                    if(video.type == 'vimeo'){
                        return `//player.vimeo.com/video/${video.videoId}?api=1&title=0&byline=0&portrait=0&autoplay=1`;
                    }
                    return `//fast.wistia.net/embed/iframe/${video.videoId}?playbar=false&amp;playButton=false&amp;controlsVisibleOnLoad=false&amp;videoFoam=false&amp;fullscreenButton=false&amp;playbackRateControl=false&amp;volumeControl=false&amp;settingsControl=false&amp;smallPlayButton=false&amp;autoplay=1`;
                }
                return '';
            },
            getVideo() {
                return this.myData.videoMediaData && this.myData.videoMediaData.video ? this.myData.videoMediaData.video : {};
            },
            getVideoId() {
                return this.myData.videoMediaData && this.myData.videoMediaData.video && this.myData.videoMediaData.video.id? this.myData.videoMediaData.video.id : '';
            },
            getVideoParams() {
                return this.myData.videoMediaData && this.myData.videoMediaData.params ? this.myData.videoMediaData.params : {};
            },
            setVideo(video){
                let updateData = this.myData.videoMediaData ? copyJson(this.myData.videoMediaData) : {};
                updateData['video'] = video;

                if (!updateData.hasOwnProperty('params')) {
                    updateData.params = {
                        autoplay : false,
                        mute : false,
                        loop : false,
                        popup : false
                    }
                }


                this.changeMyData({videoMediaData: updateData});
                this.renderVideo();
            },
            setVideoParams(params){
                let updateData = this.myData.videoMediaData ? copyJson(this.myData.videoMediaData) : {};
                updateData['params'] = params;
                this.handleVideoPopupAppearance(params);

                this.changeMyData({videoMediaData: updateData});
            },
            removeVideo (wrapper) {
                let frame = this.getFrameNode(wrapper);

                if (frame) {
                    frame.remove();
                }
            },
            createVideoFrame () {
                //let frame = document.querySelector("#dynamicElements").querySelector("iframe").cloneNode(true);
                let frame =  document.createElement('iframe');
                let attributes = {
                    "class" : "learnworlds-video-iframe  js-video-frame",
                    "frameborder" : "0",
                    "allow" : "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    "style": "height:100%; width:100%;",
                    "playsinline" : "",
                    "webkitallowfullscreen" : "",
                    "allowfullscreen" : "",
                    "mozallowfullscreen" : "",
                }

                for (let attr in attributes) {
                    if (!attributes.hasOwnProperty(attr)) {
                        continue;
                    }

                    frame.setAttribute(attr,attributes[attr]);
                }

                return frame;
            },
            handleVideoPopupAppearance (params) {
                let videoWrapper = this.getVideoWrapper();


                videoWrapper.classList.add('hide-video-icon');


                if (params && params.popup) {
                    videoWrapper.classList.remove('hide-video-icon');

                }
            },
            toggleInteractionWithFrame (flag) {
                let videoWrapper = this.getVideoWrapper();

                if (flag) {
                    videoWrapper.classList.remove('disable-screen-video-interaction');
                } else {
                    videoWrapper.classList.add('disable-screen-video-interaction');
                }
            },
            getVideoUrl () {
                if (!this.myData?.videoMediaData) {
                    return '';
                }
                const showControls =  !this.myData.videoMediaData.params.popup;
                const params = copyJson(this.myData.videoMediaData.params);

                // If is a popup video disable autoplay and enable it only on the popup
                params.autoplay = params.autoplay && !params.popup;

                if (this.myData.videoMediaData.video.type === "vimeo") {
                    return this.createVimeoUrl(this.myData.videoMediaData.video, params, showControls);
                } else if (this.myData.videoMediaData.video.type === "wistia") {
                    return this.createWistiaUrl(this.myData.videoMediaData.video, params, showControls);
                }

                return "";
            },

            getFallbackImageOrGradient () {
                let imgSrc = this.getFallbackImage();

                if (!imgSrc) {
                    return "repeating-linear-gradient(-45deg, rgb(230,230,230), rgb(230,230,230) 35px, rgb(242,242,242) 35px, rgb(242,242,242) 70px)";
                }

                return "url('" + imgSrc + "')";
            },
            getRenderVideoParams(){
                return this.myData?.videoMediaData?.params;
            },
            createVimeoUrl (video, params, showControls = false) {
                let urlParams = {
                    title : 0,
                    byline : 0,
                    portrait : 0,
                    autopause: 0
                };

                if (!showControls) {
                    urlParams.controls = 0;
                }

                let videoUrl = "https://player.vimeo.com/video/";
                videoUrl += video.videoId;

                Object.keys(params).map(videoParamKey => {
                    let videoParamValue = params[videoParamKey];

                    if (videoParamKey && videoParamValue && this.vimeoUrlKeys[videoParamKey]) {
                        urlParams[this.vimeoUrlKeys[videoParamKey]] = 1;
                    }
                });

                videoUrl = glueParamsToUrl(videoUrl,urlParams);

                return videoUrl;
            },
            createWistiaUrl (video, params, showControls = false) {
                let urlParams = {
                       playbar : true,
                       playButton : false,
                       smallPlayButton : true,
                       qualityControl : true,
                       playbackRateControl : true,
                       volumeControl : true,
                       settingsControl : true,
                       controlsVisibleOnLoad : true,
                       videoFoam : true,
                       fullscreenButton : true
                };

                if (!showControls && params.popup) {
                    urlParams.playbar = false;
                    urlParams.playButton = false;
                    urlParams.qualityControl = false;
                    urlParams.playbackRateControl = false;
                    urlParams.volumeControl = false;
                    urlParams.settingsControl = false;
                    urlParams.controlsVisibleOnLoad = false;
                    urlParams.videoFoam = false;
                    urlParams.fullscreenButton = false;
                }

                let videoUrl = "//fast.wistia.net/embed/iframe/";
                videoUrl += video.videoId ;


                Object.keys(params).map(videoParamKey => {
                    let videoParamValue = params[videoParamKey];

                    if (videoParamKey && videoParamValue && this.wistiaUrlKeys[videoParamKey]) {
                        urlParams[this.wistiaUrlKeys[videoParamKey]] = true;

                        if (videoParamKey === "loop") {
                            urlParams[this.wistiaUrlKeys[videoParamKey]] = "loop";
                        }

                        if (videoParamKey === "mute") {
                            urlParams["volumeControl"] = false;
                        }

                        //TODO move to element data
                        // let dataAttrParams = this.referenceNode.getAttribute("data-video-param") ? this.referenceNode.getAttribute("data-video-param") : "";
                        // this.referenceNode.setAttribute("data-video-param" , dataAttrParams + " " + videoParamKey);
                    }

                });

                videoUrl = glueParamsToUrl(videoUrl,urlParams);
                return videoUrl;
            },
            getHideVideoBelow() {
                if (this.myData && this.myData.hasOwnProperty('videoMediaData') && this.myData.videoMediaData && this.myData.videoMediaData.hasOwnProperty('hideVideoBelow')) {
                    return this.myData.videoMediaData.hideVideoBelow
                }

                return 'None'
            },
            setHideVideoBelow(hideVideoBelow) {
                this.changeMyData({
                    videoMediaData: {
                        ...this.myData.videoMediaData,
                        hideVideoBelow
                    }
                });
            },
            getFallbackImage() {
                if (this.myData && this.myData.hasOwnProperty('videoMediaData') && this.myData.videoMediaData && this.myData.videoMediaData.hasOwnProperty('fallbackImage')) {
                    return this.myData.videoMediaData.fallbackImage
                }
                return null
            },
            setFallBackImage(fallbackImage) {
                this.changeMyData({
                    videoMediaData: {
                        ...this.myData.videoMediaData,
                        fallbackImage
                    }
                });
            }
        }
    }
</script>

